import React, { Component } from 'react';
import './Demo.css';

class ContactSection extends Component {
    state = {
        selectedRole: '',
        formData: {
            name: '',
            email: '',
            phonenumber: '',
            pincode: '',
        },
        acceptedTerms: false,
        submitting: false,
        submitted: false,
    };

    handleRoleSelect = (role) => {
        this.setState({ selectedRole: role });
    };

    handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            this.setState({ acceptedTerms: checked });
        } else {
            this.setState((prevState) => ({
                formData: {
                    ...prevState.formData,
                    [name]: value,
                }
            }));
        }
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submitting: true });

        const formData = new FormData();
        formData.append('I_am', this.state.selectedRole);
        formData.append('acceptedTerms', this.state.acceptedTerms);
        Object.entries(this.state.formData).forEach(([key, val]) => {
            formData.append(key, val);
        });

        const scriptURL = 'https://script.google.com/macros/s/AKfycbyCu0btuLiKR7PcOPfIfRif1f-QKZh91creziglHZFjEgl1l39-uRLm7j97QpTY3ETs/exec';

        try {
            const response = await fetch(scriptURL, {
                method: 'POST',
                body: formData
            });

            if (response.ok) {
                this.setState({
                    submitting: false,
                    submitted: true,
                    formData: {
                        name: '',
                        email: '',
                        phonenumber: '',
                        pincode: ''
                    },
                    selectedRole: '',
                    acceptedTerms: false
                });
            } else {
                throw new Error('Submit failed');
            }
        } catch {
            this.setState({ submitting: false });
            alert('Failed to submit');
        }
    };

    render() {
        const { selectedRole, formData, acceptedTerms, submitting, submitted } = this.state;
        const roles = ['Business Owner', 'Accountant', 'Student', 'Others'];

        // Data for the "What is Auditus-iERP?" and similar sections
        const sectionsData = [
            {
                title: "What is Auditus-iERP?",
                content: "Auditus-iERP is an all-in-one ERP solution crafted for Indian SMEs to simplify accounting, inventory, billing, and manufacturing. Designed for GST compliance and scale, it integrates every business need into a single dashboard."
            },
            {
                title: "Is Auditus-iERP Right for You?",
                content: "If you're seeking an ERP solution that offers comprehensive features at an affordable price point, Auditus-iERP is worth considering. It's particularly beneficial for businesses looking to streamline their operations without a significant upfront investment."
            }
        ];
        const features = [
            { icon: 'fas fa-calculator', title: 'Accounting & GST Compliance', description: 'Handles financial transactions, generates GST-compliant invoices, and simplifies tax filing.' },
            { icon: 'fas fa-cogs', title: 'Inventory Management', description: 'Tracks stock levels, manages multiple warehouses, and supports barcode scanning.' },
            { icon: 'fas fa-credit-card', title: 'Billing & POS', description: 'Facilitates point-of-sale transactions with multiple payment modes and integrates with mobile devices.' },
            { icon: 'fas fa-industry', title: 'Manufacturing & BOM', description: 'Manages production processes, including Bill of Materials (BOM), production planning, and work orders.' },
            { icon: 'fas fa-building', title: 'Multi-Company Support', description: 'Allows management of multiple business units under a single account.' },
            { icon: 'fas fa-mobile-alt', title: 'Mobile App Integration', description: 'Provides a mobile application for on-the-go access to key functionalities.' },
            { icon: 'fas fa-map-marker-alt', title: 'Multi-Location Management', description: 'Seamlessly manage operations across various business locations.' },
            { icon: 'fas fa-sync-alt', title: 'Real-Time Data Sync', description: 'Synchronize data in real-time across all platforms and devices.' },
            { icon: 'fas fa-chart-line', title: 'Powerful Reporting Tools', description: 'Generate insightful financial reports and track business performance easily.' },
            { icon: 'fas fa-user-shield', title: 'Role-Based Access Control', description: 'Define specific roles and permissions to protect sensitive information.' },
            { icon: 'fas fa-desktop', title: 'Easy-to-Use Interface', description: 'Our intuitive interface ensures that even beginners can easily navigate and use the software.' },
            { icon: 'fas fa-headset', title: '24/7 Customer Support', description: 'Get help anytime with our round-the-clock customer support team.' },
            { icon: 'fas fa-cloud-upload-alt', title: 'Cloud Backup', description: 'All your data is securely backed up in the cloud, ensuring safety and availability.' },
            { icon: 'fas fa-brain', title: 'AI-Driven Insights', description: 'Leverage AI to gain actionable insights and drive smarter business decisions.' }
        ];


        return (
            <div>
                <div className="section-wrapper">
                    {/* Left content section */}
                    <div className="left-content">
                        <h1>Smarter Business Starts Here<br />All-in-One Management, Without the Headaches</h1>
                        <p>
                            Automate GST Filing & Reconciliation | Live Financial Dashboards & Banking | Intelligent Inventory Tracking |
                            Powerful Reports That Drive Growth
                        </p>
                        <button
                            className="explore-button"
                            onClick={() => window.location.href = '/Pricing'}
                        >
                            See Plans & Pricing →
                        </button>
                    </div>

                    {/* Form section */}
                    <div className="form-container">
                        <h2>Get Started with 100 Free Transactions</h2>
                        <form onSubmit={this.handleSubmit} className="styled-form">
                            <label className="label">I am *</label>
                            <div className="role-selector">
                                {roles.map(role => (
                                    <button
                                        type="button"
                                        key={role}
                                        className={`role-button ${selectedRole === role ? 'selected' : ''}`}
                                        onClick={() => this.handleRoleSelect(role)}
                                    >
                                        {role}
                                    </button>
                                ))}
                            </div>

                            <input
                                type="text"
                                name="name"
                                placeholder="Name*"
                                value={formData.name}
                                onChange={this.handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="phonenumber"
                                placeholder="Phone number*"
                                value={formData.phonenumber}
                                onChange={this.handleChange}
                                required
                            />
                            <input
                                type="email"
                                name="email"
                                placeholder="Email*"
                                value={formData.email}
                                onChange={this.handleChange}
                                required
                            />
                            <input
                                type="text"
                                name="pincode"
                                placeholder="Pincode*"
                                value={formData.pincode}
                                onChange={this.handleChange}
                                required
                            />

                            <label className="terms">
                                <input
                                    type="checkbox"
                                    checked={acceptedTerms}
                                    onChange={this.handleChange}
                                    required
                                /> I have read and accepted the <button type="button" className="terms-link">T&C</button>
                            </label>

                            <button type="submit" disabled={submitting} className="submit-button">
                                {submitting ? 'Submitting...' : 'Submit →'}
                            </button>

                            {submitted && <p className="success-msg">Thank you! We’ll be in touch soon.</p>}
                        </form>
                    </div>
                </div>

                {/* Mapping through Auditus-iERP sections */}
                <div className="auditus-ierp-section-wrapper">
                    {sectionsData.map((section, index) => (
                        <div className="auditus-ierp-section" key={index}>
                            <h2>{section.title}</h2>
                            <p>{section.content}</p>
                        </div>
                    ))}
                </div>
                <section className="features-section">
                    <h2>Key Features of Auditus-iERP</h2>
                    <ul className="feature-list">
                        {features.map((feature, index) => (
                            <li key={index}>
                                <div className="feature-item">
                                    <h3><i className={feature.icon}></i> {feature.title}</h3>
                                    <p>{feature.description}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </section>

                <section className="learning-resources">
                    <h2>Learning Resources</h2>
                    <div className="video-grid">
                        {[
                            { src: "0admRt0rvYc", title: "Installation Guide", description: "Step-by-step process to download and install Auditus-iERP software." },
                            { src: "xClW7EH2Cmk", title: "POS Billing Tutorial", description: "Learn how to handle multiple payment modes with Auditus ERP's POS system." },
                            { src: "npFtyEu9Wdc", title: "Price Level Configuration", description: "Understand how to manage price levels for different customer types." },
                            { src: "sR9PPzzpzdE", title: "Sale Entry Guide", description: "Comprehensive guide on recording sales entries in Auditus-iERP." },
                            { src: "-97Ur-Obf9Y", title: "Payment & Receipt Voucher Entry", description: "Learn how to record payments and receipts efficiently." },
                            { src: "O1afn3a-C8A", title: "Multi-Company Setup", description: "Guide on configuring Auditus-iERP for multiple companies." },
                            { src: "aH8Gd9BdjEI", title: "Head Office & Branch Integration", description: "Explore integration between head office and branch operations." },
                            { src: "d5MC3LHy_VE", title: "Dashboard Sales Analysis", description: "Utilize the dashboard for insightful sales data analysis." },
                            { src: "QIezkPi-Suk", title: "Supermarket Pricing Automation", description: "Automate pricing strategies for supermarket operations." },
                            { src: "st53YwJ15xs", title: "Production & BOM Management", description: "Manage production processes and Bills of Materials effectively." }
                        ].map((video, index) => (
                            <div className="video-card" key={index}>
                                <iframe src={`https://www.youtube.com/embed/${video.src}`} title={video.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowFullScreen />
                                <h3>{video.title}</h3>
                                <p>{video.description}</p>
                            </div>
                        ))}
                    </div>
                </section>
         
            </div>
        );
    }
}

export default ContactSection;
